import { apiClient } from './api';
import type {
  ProgramPeriodizationOverview,
  ProgramPeriodBlock,
  ProgramPeriodRecommendation,
  ProgramPeriodTransition,
} from './types';

interface EnablePeriodizationResponse {
  message: string;
  programId: number;
  periodizationEnabled: boolean;
  currentPeriodType?: string | null;
  activeBlock: ProgramPeriodBlock;
}

export class ProgramPeriodizationService {
  private static readonly ENDPOINT = '/api/program-periodization';

  static async getOverview(programId: number): Promise<ProgramPeriodizationOverview> {
    const response = await apiClient.get<ProgramPeriodizationOverview>(`${this.ENDPOINT}/${programId}`);
    return response.data;
  }

  static async enable(programId: number, payload: Record<string, unknown> = {}): Promise<EnablePeriodizationResponse> {
    const response = await apiClient.post<EnablePeriodizationResponse>(`${this.ENDPOINT}/${programId}/enable`, payload);
    return response.data;
  }

  static async createBlock(programId: number, payload: Record<string, unknown>): Promise<{ message: string; block: ProgramPeriodBlock }> {
    const response = await apiClient.post<{ message: string; block: ProgramPeriodBlock }>(`${this.ENDPOINT}/${programId}/blocks`, payload);
    return response.data;
  }

  static async updateBlock(programId: number, blockId: number, payload: Record<string, unknown>): Promise<{ message: string; block: ProgramPeriodBlock }> {
    const response = await apiClient.patch<{ message: string; block: ProgramPeriodBlock }>(`${this.ENDPOINT}/${programId}/blocks/${blockId}`, payload);
    return response.data;
  }

  static async transition(programId: number, payload: Record<string, unknown>): Promise<{ message: string; transition: ProgramPeriodTransition; activeBlock: ProgramPeriodBlock }> {
    const response = await apiClient.post<{ message: string; transition: ProgramPeriodTransition; activeBlock: ProgramPeriodBlock }>(`${this.ENDPOINT}/${programId}/transition`, payload);
    return response.data;
  }

  static async getRecommendation(programId: number): Promise<{ programId: number; recommendation: ProgramPeriodRecommendation }> {
    const response = await apiClient.get<{ programId: number; recommendation: ProgramPeriodRecommendation }>(`${this.ENDPOINT}/${programId}/recommendation`);
    return response.data;
  }
}
